import { observer } from "mobx-react-lite";
import { FC } from "react";
import { ImageUploadRejectedModalStore } from "@/components/modal/image-upload-rejected/image-upload-rejected-modal-store";
import {
  MDSText,
  MDSTextVariant,
  MDSModalDialog,
  MDSDialogSlotName,
  MDSDialogTextContent,
} from "@/mds";

export interface ImageUploadRejectedModalProps {
  store: ImageUploadRejectedModalStore;
}

export const ImageUploadRejectedModal: FC<ImageUploadRejectedModalProps> = observer(({ store }) => {
  return (
    <MDSModalDialog isOpen={store.isOpen} handleClose={() => store.close()}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        Upload failed
      </MDSText>
      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphS}>{store.errorSummary}</MDSText>
        <MDSText variant={MDSTextVariant.ParagraphS}>{store.errorMessage}</MDSText>
      </MDSDialogTextContent>
    </MDSModalDialog>
  );
});
